<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý khách hàng</div>
      </div>
      <div class="card card-w-title">
        <div class="import-data download-data" v-if="checkVisible('customer', 'download')">
          <button class="download-file" @click="exportDataExcel">
            <i class="pi pi-download"></i>Tải danh sách
          </button>
          <span >(Danh sách khách hàng được tải về theo điều kiện lọc đã nhập)</span>
        </div>
        <div class="list-data">
          <div class="list-title">
            <span class="p-m-0"> Danh sách khách hàng</span>
          </div>
          <BaseCommon v-if="dataModel"
            :key="componentKey"
            :listData="listData"
            :model="dataModel"
            :filterDefault="filters"
            :actions="getRowActions()"
            :columnsDisplays="columnsDisplays"
            v-on:action-click="onActionClicked"
            @callback="callback"
            @filter="filterData"
            @clearFilter="cancelFilter"
            @filterExport="filterExport"
          ></BaseCommon>
        </div>
      </div>
    </div>
    <Dialog
        class="dialog-comfirm-common"
        :visible.sync="showConfirmDialog"
        :contentStyle="{overflow: 'visible'}"
        :modal="true"
        :closable="true"
    >
      <div class="box_body_popup" >
        <div v-if="creenConfirmDialog == 'export_success'">
          <div class="box_title_suceess"><img class="img_noti" :src="check_success_img" /><span class="title_noti" style="">Thành công</span></div>
          <p class="p_title_1" style="text-align: left"><span style="font-weight: 700">Danh sách khách hàng</span> đã xuất dữ liệu thành công. Vui lòng thực hiện tải về tại module Lịch sử xuất dữ liệu.</p>
          <div class="box_btn">
            <Button
                icon="pi pi-chevron-circle-right"
                iconPos="right"
                class="btn-custom"
                :label="'Lịch sử xuất dữ liệu'"
                type="button"
                @click="redirect_ToHistory"
            > </Button>
          </div>
        </div>
        <div v-if="creenConfirmDialog == 'export_err'">
          <div class="box_title_err"><img class="img_noti" :src="err_massage_img" /><span class="title_noti" style="">Thất bại</span></div>
          <p class="p_title_1" style="text-align: left">Quá trình xuất dữ liệu <span style="font-weight: 700;">Danh sách khách hàng</span> đã xảy ra vấn đề. Bạn vui lòng thực hiện lại thao tác xuất dữ liệu.</p>
        </div>
      </div>
      <template #header>
        <div>
          <span class="title-confirm" >Thông báo</span>
          <!--<span class="description-confirm">asdasdas</span>-->
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
//import BaseCommon from '../common'
import BaseCommon from './core_list';
import moment from 'moment'
import XLSX from 'xlsx'
export default {
  components: {
    BaseCommon
  },
  data() {
    return {
      filters: {},
      listData: [],
      dataModel: null,
      componentKey: 0,
      listExport: [],
      columnsDisplays: [],
      creenConfirmDialog:'export_success',
      check_success_img: window.origin + '/assets/images/check_success.png',
      err_massage_img: window.origin + '/assets/images/err_massage.png',
      showConfirmDialog:false,
      listDataExport:[],
      userID : null,
      data_filter_export:null
    }
  },
  mounted () {
    this.initData();
    if(this.$store.getters.fullname !== undefined && this.$store.getters.fullname !== null){
      if(this.$store.getters.fullname.id !== undefined && this.$store.getters.fullname.id !== null && this.$store.getters.fullname.id !== ''){
        this.userID = this.$store.getters.fullname.id
      }
    }
  },
  created () {
    if(this.$route.params.reload) {
      window.location.reload();
    }
  },
  watch: {
    '$route': 'initData'
  },
  methods: {
    initData() {
      setTimeout(async () => {
        if (this.checkVisible('customer', 'list')) {
          await this.initParams();
        }
      }, 1000);
    },
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    callback(col, payload) {
      if (col.name == 'list_activation') {
        if (this.checkVisible('warranty_activation', 'list')) {
          this.$router.push({name: 'warranty_activation', params: {phone_number: payload.phoneNumber}});
        }
      }
      else if (col.name == 'list_warranty') {
        //this.$toast.add({ severity: 'warn', summary: 'Thông báo', detail: 'Đang xây dựng', life: 3000 })
        if (this.checkVisible('warranty_activation', 'list')) {
          this.$router.push({name: 'warranty_repair', params: {phone_number: payload.phoneNumber}});
        }
      } else if(col.key == 'history') {
        if (this.checkVisible('customer', 'history')) {
          this.$router.push({path: '/admin/customer/history/' + payload.id});
        }
      }
    },
    async initParams() {
      /*this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      this.limitPage = parseInt(localStorage.getItem('PAGINATION_ROWS'));
      this.offsetPage = ( this.currentPage - 1) * this.limitPage;*/
      this.modelName = 'customer';
      /*var organization = this.$myConstants.organizationUserLogin();
      var creator_organization_id = (!this.$myConstants.isEmpty(organization.id)) ? organization.id:null;
      var id_organization_hong_ky =await this.$coreService.id_organization_hong_ky();
      var whereKey = {
        status: {'_in': [1] },
        full_name: {'_neq': ''},
        phone_number: {'_neq': ''},
        user: {
          user_type: {'_in': [1]},
        }
      }
      //Phân quyền dữ liệu
      var is_management_units = false;
      if (parseFloat(id_organization_hong_ky) ==  creator_organization_id){
        if (!this.$myConstants.isEmpty(this.$store.getters.fullname.is_management_units)){
          if (this.$store.getters.fullname.is_management_units == true){
            is_management_units = true;
          }
        }
      }
      var whereOr = [];
      if (is_management_units == false){
        //whereKey.user.creator_organization_id = {'_eq': creator_organization_id};
        whereOr.push({
          user:{creator_organization_id:{'_eq': creator_organization_id}}
        })
      }*/

      /*if (this.$store.getters.fullname.user_type == 2) {
        whereOr.push({
          request_activation:{
            author_id: {'_eq': this.$store.getters.fullname.id }
          }
        });*/
        /*whereKey = Object.assign(whereKey,  {
          request_activation: {
            author_id: {'_eq': this.$store.getters.fullname.id } 
          }
        }) */
      //}
     /* if (whereOr.length>0){
        whereKey = Object.assign(whereKey,
            { "_and": {
                "_or": whereOr
              }
            }
        );
      }
      var variables = {
        where_key: whereKey,
        orderBy: {
          //modified_date: 'desc_nulls_last',
          id: 'desc_nulls_last'
        }
      }
      var variablesLimit = variables;

      var dataLimit = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variablesLimit)});
      var listLimit = dataLimit[Object.keys(dataLimit)];*/
      this.dataModel = DataServices.getModel(this.modelName);
      if (!this.checkVisible('warranty_activation', 'list')) {
        this.columnsDisplays.push('list_activation')
      }
      if (!this.checkVisible('customer', 'history')) {
        this.columnsDisplays.push('history')
      }
      if (!this.checkVisible('warranty_repair', 'list')) {
        this.columnsDisplays.push('list_warranty')
      }
      this.dataModel.processData([]);
      this.listData = [];
      // this.listExport = this.listData;
      this.listDataExport = this.listData;
      this.componentKey++;
      //this.$store.commit('setLoading', false);
    },
    onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'edit':
          if (this.checkVisible('customer', 'edit')) {
            if (data && Object.keys(data).length) {
              this.$router.push({path: '/admin/customer/function/' + data.data.id});
            }
          }
          break;
      }
    },
    getRowActions() {
      var actions = {}
      var that = this;
      actions.filter = { name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        var buttons = {}
        if (that.checkVisible('customer', 'edit')) {
          buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `admin/product-${this.modelName}/edit`}
          if (that.dataModel.actions) {
            var modelaction = that.dataModel.actions(rowData)
            Object.assign(buttons, modelaction);
          }
        }
        return buttons
      }
      return actions
    },
    cancelFilter() {
      this.filters = {};
      // this.componentKey++;
      this.listDataExport = this.listData;
    },
    filterData(payload) {
      this.listDataExport = payload.filteredValue;
    },
    async  exportDataExcel(){
      //var list_id_customer = [];
      if (this.data_filter_export.is_data == 0){
        this.$toast.add({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Không tồn tại dữ liệu xuất',
          life: 3000
        });
        return false;
      }
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
     /* for (var i=0;i<this.listDataExport.length;i++){
        list_id_customer.push(this.listDataExport[i].id);
      }*/
        this.data_filter_export.columnsDisplays = this.columnsDisplays;
        try {
          var dataResponse = await this.$coreService.callApiPost('/export_excel/list_customer',{data_filter_export:this.data_filter_export,user_id : this.userID},{})
          var key_s3 = dataResponse.data.data.key_s3;
          var dataResponseDownload = await this.$coreService.callApiDownloadPost('/export_excel/read_file_export',{key_s3:key_s3},{})
          var url = URL.createObjectURL(new Blob([dataResponseDownload.data], {
            type: 'application/vnd.ms-excel'
          }))
          const link = document.createElement('a')
          link.href = url;
          var file_excel = 'DanhSachKhachHang_'+moment().tz("Asia/Bangkok").format('DDMMYYYY')+'_'+moment().tz("Asia/Bangkok").format('HHmmss')+'.xlsx';
          link.setAttribute('download', file_excel)
          document.body.appendChild(link)
          link.click()
          this.showConfirmDialog = true;
          this.creenConfirmDialog = 'export_success';

      } catch (err) {
          console.log("err:",err);
          this.showConfirmDialog = true;
          this.creenConfirmDialog = 'export_err';
        }
      this.$store.commit('setLoading', false);
    },
    dang_phat_trien(){
      alert('Đang phát triển');
    },
    redirect_ToHistory(){
      this.$router.push({path: '/admin/history-export'});
    },
    // exportDataExcel() {
    //   if (this.listExport.length > 0) {
    //     this.$store.commit('setDataLoading', {content: 'Đang tải file', icon: true});
    //     this.$store.commit('setLoading', true);
    //     var vm = this;
    //     setTimeout(() => {
    //       vm.exportExcel();
    //     }, 1000);
    //   }
    // },
    customerType($type) {
      if ($type == 1) return 'Cá nhân';
      else if ($type == 2) return 'Doanh nghiệp';
      return '';
    },
    exportExcel() {
      var dataJson = [];
      for (let index = 0; index < this.listExport.length; index++) {
        var item = this.listExport[index];
        dataJson.push({
          'STT': (index + 1),
          'Tên khách hàng': (item['full_name'] != undefined && item['full_name'] != null) ? item['full_name']: '',
          'Số điện thoại': (item['phone_number'] != undefined && item['phone_number'] != null && item['phone_number'] != '') ? item['phone_number'].replace('+84', '0'): '',
          'Nhóm khách hàng': (item['customer_type'] != undefined && item['customer_type'] != null) ? this.customerType(item['customer_type']): '',
          'Ngày sinh': (item['birthday'] != undefined && item['birthday'] != null && item['birthday'] != '') ? moment(item['birthday']).format('DD/MM/YYYY'): '',
          'Email': (item['email'] != undefined && item['email'] != null) ? item['email']: '',
          'Tỉnh/Thành phố': (item['province'] != undefined && item['province'] != null && item['province'].name != undefined) ? item['province'].name: '',
          'Quận/Huyện': (item['district'] != undefined && item['district'] != null && item['district'].name != undefined) ? item['district'].name: '',
          'Phường/Xã': (item['ward'] != undefined && item['ward'] != null && item['ward'].name != undefined) ? item['ward'].name: '',
          'Số nhà': (item['address'] != undefined && item['address'] != null) ? item['address']: ''
        });
      }
      if (dataJson !== null) {
        var d = new Date();
        var fileName = 'DanhSachKhachHang_'  + moment(d).format('DDMMYYYY') + '_' + moment(d).format('HHmmss');
        var dataSheet = XLSX.utils.json_to_sheet(dataJson) 
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, dataSheet)
        XLSX.writeFile(wb, fileName + '.xlsx')
        this.$store.commit('setLoading', false);
      }
    },
    async filterExport(e){
      //console.log("EEE",e)
      this.data_filter_export = e
    }
  }
}
</script>
<style lang="scss">
.box-filters{ margin: 15px 0;
  .p-formgroup-inline { display: flex;flex-wrap: wrap; align-items: flex-start;
    .p-field{ margin-right: 50px; margin-bottom: 15px;
      &:last-child{margin: 0; position: relative;}
      label{display: block;}
      .p-dropdown, input{width: 230px;}
      .btn-cancel{width: 90px;position: absolute; top: 30px;}
    }
  }
}
.import-data .download-file {
    color: #fff;
    border-width: 0px;
    min-width: 165px;
    height: 35px;
    background: #169bd5;
    border: none;
    border-radius: 5px;
    padding: 5px 20px;
}
.download-data{ position: relative; display: flex;
  span{margin-top: 14px; margin-left: 10px;}
}
.external-link{ color: #0066FF; cursor: pointer;
  &.black-color {
    span{color: #000;}
  }
  span{color: #199ED8;}
}
.list_warranty_repair{
  .late_delivery_return_appointment_day{
    color: #CC0000;
  }
}

.import-data .download-file {
  color: #fff;
  border-width: 0px;
  min-width: 165px;
  height: 35px;
  background: #169bd5;
  border: none;
  border-radius: 5px;
  padding: 5px 20px;
}
.download-data{ position: relative; display: flex;
  span{margin-top: 14px; margin-left: 10px;}
}

.dialog-comfirm-common{
  width: 434px;
  .p-dialog-header{
    padding-bottom: 4px; padding-top: 4px;
  }
  .box_body_popup{
    width: 100%;
    .p_title_1{
      text-align: center;margin-bottom: 0px;
    }
    .p_title_2{
      text-align: center;
    }
    .box_btn{
      text-align: center;
      margin-top: 8px;
    }
    .box_title_suceess{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #009900;margin-left: 8px
      }
    }
    .box_title_err{
      margin-bottom: 10px;
      .img_noti{
        width: 20px;
        height: 20px;
      }
      .title_noti{
        font-family: 'Arial Bold', 'Arial'; font-weight: 700; font-style: normal; font-size: 18px; color: #FF0000;margin-left: 8px
      }
    }
  }
}
</style>